import { render } from "./FormRelOneFile.vue?vue&type=template&id=dd98d186"
import script from "./FormRelOneFile.vue?vue&type=script&lang=js"
export * from "./FormRelOneFile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelOneFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd98d186"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd98d186', __exports__)) {
    console.log('reload')
    api.reload('dd98d186', __exports__)
  }
  
  module.hot.accept("./FormRelOneFile.vue?vue&type=template&id=dd98d186", () => {
    console.log('re-render')
    api.rerender('dd98d186', render)
  })

}


export default __exports__